<script setup>
defineProps({
  text: {
    type: String,
    default: '',
  },
  typography: {
    type: String,
    default: 'h1000',
  },
  alignment: {
    type: String,
    default: 'left',
  },
});
</script>

<template>
  <div class="mb-8">
    <span :aria-label="$t('global.title')"></span>
    <p :aria-label="text" :class="[typography, `text-${alignment}`]">
      {{ text }}
    </p>
  </div>
</template>
